/**
 * @file FilterActions.tsx
 * @desc Action buttons component for custom filter
 * @copyright All rights reserved @ Inarix
 */
import React from "react";
import { Box, Button } from "@mui/material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { TFunction } from "i18next";
import { customFilterFormStyles } from "../../dataTable/table/customFilterForm/CustomFilterFormStyles";

interface FilterActionsProps {
  t: TFunction<"global", undefined>;
  onAddFilter: () => void;
  onClearAll: () => void;
  onApplyFilter: () => void;
}

export const FilterActions: React.FC<FilterActionsProps> = ({
  t,
  onAddFilter,
  onClearAll,
  onApplyFilter,
}) => {
  return (
    <Box sx={customFilterFormStyles.actionButtonsContainer}>
      <Button
        startIcon={<span style={customFilterFormStyles.iconStyle}>+</span>}
        sx={customFilterFormStyles.actionButton}
        onClick={onAddFilter}
      >
        {t("custom_filter.add_filter")}
      </Button>

      <Button
        startIcon={
          <span style={customFilterFormStyles.iconStyle}>
            <DeleteForeverIcon fontSize="small" />
          </span>
        }
        sx={customFilterFormStyles.actionButton}
        onClick={onClearAll}
      >
        {t("custom_filter.remove_all")}
      </Button>

      <Button
        variant="contained"
        onClick={onApplyFilter}
        sx={customFilterFormStyles.applyButton}
      >
        {t("Common_options.Apply")}
      </Button>
    </Box>
  );
};
